import {apiSlice} from '../apiSlice';

const SETTINGS_URL = '/settings';

export const settingsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        profileUpdate: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${SETTINGS_URL}/profile/update/${id}`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        passwordUpdate: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${SETTINGS_URL}/password/update/${id}`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        getNotifications: builder.query({
            query: (token) => ({
                url: `${SETTINGS_URL}/notifications`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        newNotification: builder.mutation({
            query: ({token, data}) => ({
                url: `${SETTINGS_URL}/notifications/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        deleteNotification: builder.mutation({
            query: ({token, id}) => ({
                url: `${SETTINGS_URL}/notifications/delete/${id}`,
                method: 'DELETE',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        updateNotification: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${SETTINGS_URL}/notifications/update/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        })
    }),
});

export const {
    usePasswordUpdateMutation,
    useGetNotificationsQuery,
    useNewNotificationMutation,
    useProfileUpdateMutation,
    useDeleteNotificationMutation,
    useUpdateNotificationMutation,
} = settingsApiSlice;
